import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";
import type { CosignDocumentBody } from "@/core/types/(api)/cosignature";
import type { UUID } from "@/core/types";

// noteId is used for cache invalidation only, not sent to the backend
export type CosignDocumentVariables = CosignDocumentBody & { documentId: string; noteId: UUID };

export async function cosignDocument({
  documentId,
  noteId: _noteId,
  ...body
}: CosignDocumentVariables): Promise<void> {
  return cosignatureRequestsTyped.cosign_document({ body, urlParams: { documentId } });
}
